import { isFunction, isUndefined } from 'lodash';

export default function(template, values) {
    return template.replace(/\{ *([\w_]+) *\}/g, (_, key) => {
        let value = values[key];

        if (isUndefined(value)) {
            return '{' + key + '}';
        }

        if (isFunction(value)) {
            value = value(key);
        }

        return key === 'query' ? encodeURIComponent(value) : value;
    });
}



// WEBPACK FOOTER //
// ./services/requester/template.js